import { MessageCircle } from "lucide-react";
import { useSettings } from "@/lib/hooks";
import { waLink } from "@/lib/api";

export default function WhatsAppFab() {
  const s = useSettings();
  if (!s?.whatsapp_number) return null;
  return (
    <a data-testid="whatsapp-fab" href={waLink(s.whatsapp_number, s.whatsapp_message)} target="_blank" rel="noreferrer"
      className="fixed bottom-5 right-5 z-50 h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl hover:scale-110 transition-transform"
      aria-label="WhatsApp ile sipariş">
      <MessageCircle className="h-7 w-7" />
    </a>
  );
}
